import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FreeFormAgendaService } from '../service/free-form-agenda.service';

@Pipe({
  name: 'safeAgneda'
})
export class SafeAgnedaPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer,private commonAgService:FreeFormAgendaService) { }

  transform(agList:any) {
    return this.constructAgSec(agList);
  }
  //Method to construct agenda section
  constructAgSec(agList:any){
    let tempHtml = '';
    if (agList != null && agList != undefined) {
      // 1) Preserve user HTML and line breaks; just strip hidden BOM/ZWSP
      const container = document.createElement('div');
      const rawTitle = (agList.agendaTitle || '').replace(/[\uFEFF\u200B]/g, '');
      container.innerHTML = rawTitle;

      // Helper: get a safe insertion target (last paragraph if present)
      const getInsertTarget = (): HTMLElement => {
        const lastP = container.querySelector('p:last-of-type') as HTMLElement | null;
        return lastP || container;
      };

      // 2) Append presenters INSIDE the last paragraph, only if not already present
      if (agList.agendaPresenterList?.length && !container.querySelector('.presentedByCls')) {
        const target = getInsertTarget();
        // ensure preceding space
        if (target.lastChild && target.lastChild.nodeType === Node.TEXT_NODE) {
          const t = target.lastChild as Text;
          if (!/[\s\u00A0]$/.test(t.data)) t.data += ' ';
        } else {
          target.appendChild(document.createTextNode(' '));
        }
        const label = document.createElement('span');
        label.className = 'presentedByCls';
        label.setAttribute('contenteditable', 'false');
        label.innerHTML = 'Presented by&nbsp;';
        target.appendChild(label);

        agList.agendaPresenterList.forEach((p: any, idx: number) => {
          const span = document.createElement('span');
          span.className = 'atwho-inserted';
          span.setAttribute('data-atwho-at-query', '@');
          if (p?.presenterUserId != null) {
            span.setAttribute('id', String(p.presenterUserId));
            span.setAttribute('fkuserid', String(p.presenterUserId));
          }
          span.setAttribute('contenteditable', 'false');
          // Add comma inside span if not the last presenter
          let spanText = String(p?.presenterName || '').trim();
          if (agList.agendaPresenterList.length > 1 && idx < agList.agendaPresenterList.length - 1) {
            spanText += ', ';
          } else {
            spanText += ' ';
          }
          span.textContent = spanText;
          target.appendChild(span);
        });
      }

      // 3) Auto-insert duration ONLY if not already present and value > 0
      const alreadyHasDuration = !!container.querySelector('.agDurCls');
      const minutesVal = Number(agList.agendaDuration || 0);
      if (!alreadyHasDuration && minutesVal > 0) {
        const target = getInsertTarget();
        // ensure preceding space
        if (target.lastChild && target.lastChild.nodeType === Node.TEXT_NODE) {
          const t = target.lastChild as Text;
          if (!/[\s\u00A0]$/.test(t.data)) t.data += ' ';
        } else {
          target.appendChild(document.createTextNode(' '));
        }
        const dur = document.createElement('span');
        dur.className = 'agDurCls';
        dur.setAttribute('contenteditable', 'false');
        dur.setAttribute('data-minutes', String(minutesVal));
        const left = document.createElement('span'); left.className = 'agDurLabelCls'; left.textContent = '[ ';
        const right = document.createElement('span'); right.className = 'agDurLabelCls'; right.textContent = ' Minutes ]';
        dur.appendChild(left);
        dur.appendChild(document.createTextNode(String(minutesVal)));
        dur.appendChild(right);
        target.appendChild(dur);
        // Use a non-breaking space so caret can appear after the non-editable duration chip
        target.appendChild(document.createTextNode('\u00A0'));
      }

      tempHtml = container.innerHTML;
    }
    return tempHtml || '';
  }

}
